import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'base64'
})
export class Base64Pipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if(args == 'encode'){
      return btoa(value);
    }
    if(args == 'decode'){
      return atob(value);
    }
  }

}
